export default __webpack_public_path__ + "static/media/ruler.61130597.png";